import React from "react";
import PropTypes from "prop-types";
// import { Image } from "react-bootstrap";

import { loginTypeConstant } from "../../constant/loginType/loginTypeConstant";

const UserLeftDetail = ({ userDetailData, loginType }) => {
  // const showImage = (imagesList) => {
  //   return imagesList.map((imageData, index) => (
  //     <div
  //       className="col-xl-3 col-lg-3 col-md-12 col-sm-12 mb-2"
  //       key={index}
  //     >
  //       <Image src={imageData} thumbnail />
  //       {/* <Button variant="danger" size="sm" className="mt-2">
  //         Delete
  //       </Button> */}
  //     </div>
  //   ));
  // };

  return (
    <>
      <div className="card bg-primary">
        <div className="card-body profile-user-box">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8">
              <div className="media">
                <div className="media-body">
                  <h4 className="mt-1 mb-1 text-white">
                    {userDetailData.workerFirstName +
                      " " +
                      userDetailData.workerSurname}
                  </h4>
                  <p className="font-13 text-white-50">
                    {userDetailData.workerDepartment +
                      " / " +
                      userDetailData.workerDesignation}
                  </p>

                  <ul className="mb-0 list-inline text-light">
                    <li className="list-inline-item mr-3">
                      <h5 className="mb-1">
                        {userDetailData.workerId}
                      </h5>
                      <p className="mb-0 font-13 text-white-50">
                        {loginType === loginTypeConstant.Employee
                          ? "Employee ID"
                          : "Worker ID"}
                      </p>
                    </li>
                    <li className="list-inline-item  mr-3">
                      <h5 className="mb-1">
                        {userDetailData.allowFencing
                          ? "Activate"
                          : "De-Activate"}
                      </h5>
                      <p className="mb-0 font-13 text-white-50">
                        Geo-fencing
                      </p>
                    </li>
                    <li className="list-inline-item">
                      <h5 className="mb-1">
                        {userDetailData.isActive
                          ? "REGULAR"
                          : "DE-ACTIVATE"}
                      </h5>
                      <p className="mb-0 font-13 text-white-50">
                        Status
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h4 className="header-title mt-0 mb-3">
            {loginType === loginTypeConstant.Employee
              ? "Employee Information"
              : "Worker Information"}
          </h4>

          <hr />

          <div className="text-left">
            <p className="text-muted">
              <strong>Full Name :</strong>{" "}
              <span className="ml-2">
                {userDetailData.workerFirstName +
                  " " +
                  userDetailData.workerSurname}
              </span>
            </p>

            <p className="text-muted">
              <strong>Mobile :</strong>
              <span className="ml-2">
                {userDetailData.workerPhoneNumber}
              </span>
            </p>

            <p className="text-muted">
              <strong>Email :</strong>{" "}
              <span className="ml-2">
                {userDetailData.workerEmail}
              </span>
            </p>

            <p className="text-muted">
              <strong>Location :</strong>{" "}
              <span className="ml-2">
                {userDetailData.lastLocationId.locationName}
              </span>
            </p>

            <p className="text-muted">
              <strong>Aadhar Card Number :</strong>
              <span className="ml-2">
                {userDetailData.workerAadharCardNumber}
              </span>
            </p>
          </div>
        </div>
      </div>
      {/* <div className="card text-white bg-info">
        <div className="card-body">
          <div className="row text-center">
            {showImage(userDetailData?.registerFaceImages)}
          </div>
        </div>
      </div> */}
    </>
  );
};

UserLeftDetail.propTypes = {
  userDetailData: PropTypes.object.isRequired,
  loginType: PropTypes.string.isRequired
};

export default UserLeftDetail;
